import { SelectOption } from '../../Select/Select.types';

export type HealthChartType = 'absolute' | 'change';

export const HEALTH_CHART_TYPES: SelectOption<HealthChartType>[] = [
  { label: 'Absolute (0 - 100)', value: 'absolute' },
  { label: '% Change', value: 'change' },
];
